<template>
  <figure class="image-caption">
    <img
      :src="image.url"
      class="image-caption__image"
      :alt="image.alt"
    />
    <figcaption
      v-if="caption"
      class="image-caption__caption p xsmall"
    >
      {{ caption }}
    </figcaption>
  </figure>
</template>

<script>

export default {
  name: 'Picture',
  props: {
    image: {
      type: Object,
      required: true
    },
    caption: {
      type: [String, Boolean],
      default: false
    }
  }
}
</script>

<style lang="scss">

.image-caption {
  padding: 0 $padding;
  margin-top: $small-space-top;
  &--close {
    margin-top: rem(10);
  }
  &__image {
    width: 100%;
    height: $image-caption-height;
    object-fit: cover;
  }
  &__caption {
    color: $image-caption-color;
    margin-top: $image-caption-margin-top;
  }
}
</style>

<docs>
  ```vue
  <Picture caption="Test voor caption"
         :image="{
id: 'images::hotel/2611e-restaurant0003.png',
url: 'http://hotel-api.test/storage/hotel/2611e-restaurant0003.png',
permalink: 'http://hotel-api.test/storage/hotel/2611e-restaurant0003.png',
api_url: 'http://hotel-api.test/content-api/assets/images/hotel/2611e-restaurant0003.png',
width: 375,
height: 320,
alt: null
}"
  />
  ```
</docs>
